import FieldDefs from './BackLinksIpFieldDefs';
import {doLangFields} from '../../lib/ks-tools';
import BacklinksIpSelector from "./mixins/Selector";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    mixins: [BacklinksIpSelector],
    data() {
        return {
            fields: doLangFields(this, "lang.report.backlinks_ip.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'backlinks_count',
                    direction: 'desc'
                }
            ],
            moreParams: {},
            additionalActions: [],
            viewMode: '',
        }
    },
    computed: {
        getApiUrl(){
            return '/report/simple/links/backlinks-ip?domain=' + this.domain;
        },
        self() {
            return this;
        },
    },
}
